export const MASSIVE_EMPLOYEE_DEACTIVATION_WIZARD_NAMESPACE =
  'massive-employee-deactivation';

export const MASSIVE_DEACTIVATION_STEPS = {
  EMPLOYEES_SELECTION: 'employees-selection',
  DEACTIVATION_RECAP: 'deactivation-recap',
} as const;
